import LayerMetadataSelect from './LayerMetadataSelect'
import { SelectOption } from './OptionSelect'
import TooltipWrapper from '../atoms/TooltipWrapper'
import { clipOutputLockReason } from 'src/enviroment/utils/clipOutputLockReason'
import { LayerItem, LayerType } from 'src/types/layer'

const CLIP_OUTPUT_OPTIONS: SelectOption<LayerType>[] = [
  { label: 'Vector', value: LayerType.VECTOR },
  { label: 'Raster', value: LayerType.RASTER },
]

const toClipOutputPayload = (clipOutputType: LayerType) => ({ clipOutputType })

interface LayerClipOutputSelectProps {
  layer: LayerItem
  className?: string
}

const LayerClipOutputSelect = ({ layer, className }: LayerClipOutputSelectProps) => {
  const lockReason = clipOutputLockReason(layer)

  const select = (
    <LayerMetadataSelect
      fileId={layer.id}
      value={layer.clipOutputType}
      options={CLIP_OUTPUT_OPTIONS}
      toPayload={toClipOutputPayload}
      disabled={lockReason !== null}
      className={className}
    />
  )

  if (!lockReason) return select

  // Tooltip trigger (asChild) needs a DOM element for its ref; LayerMetadataSelect doesn't forward one.
  return (
    <TooltipWrapper content={lockReason} contentClassName="text-sm">
      <span className="inline-block">{select}</span>
    </TooltipWrapper>
  )
}

export default LayerClipOutputSelect
